module.exports = __webpack_public_path__ + "media/images/emblems/Fluehli_LU-80d857a65c7b6d7d7d0edfd4e8c3554b.png";